import styled from 'styled-components';
import SelectModal from '../select/select-modal/SelectModal';
import { SelectOption } from '../select/select-modal/SelectModalOption';
export const StyledSelectModal = styled(SelectModal) `
  position: initial;
  border: none;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.highL};
  height: 4.3rem;
  width: auto;
  padding: 0.6rem;
  align-items: center;

  .select-dropdown-icon {
    padding: 0 0.4rem;
    path {
      fill: ${({ theme }) => theme.colors.text.default};
      stroke: ${({ theme }) => theme.colors.text.default};
    }
  }

  .select-value__wrapper {
    ${({ theme }) => theme.media.mobileM `
      align-items: center;
    
      span {
        display: inline;
      }
      .select-dropdown-icon {
        padding: 0 0.8rem;
      }
        .select-icon {
          margin-right: 1.2rem;
        }
      
    `}
  }

  button {
    padding: 0;
  }

  li {
    button {
      padding: 0 2rem;
    }
  }

  ${({ theme }) => {
    const backgroundColor = theme.colors.surface.default;
    return theme.media.laptop `
    &:hover {
      border: none;
      background-color: ${backgroundColor}
    }
    `;
}}
`;
export const CurrencySelectContainer = styled.div `
  ${StyledSelectModal} {
    padding-right: ${({ optionsLength }) => optionsLength && optionsLength > 1 ? '1rem' : '1.6rem'};
    .select-dropdown-icon {
      path {
        stroke: ${({ theme }) => theme.colors.text.secondary};
      }
    }
    .select-value__wrapper {
      gap: 0.8rem;
      align-items: center;
      .select-icon {
        margin-right: 0;
      }
    }

    ${({ theme }) => theme.media.laptop `  
     .emptyStateImg {
        height: 20rem;
     }
  `}
  }
`;
export const CustomSelect = StyledSelectModal;
export const CustomSelectOption = styled(SelectOption) `
  width: auto;
`;
//# sourceMappingURL=styles.js.map